import React from 'react'
import ApolloClient from 'apollo-boost'
import { ApolloProvider } from '@apollo/react-hooks'

const dev = process.env.NODE_ENV !== 'production'
const uri = dev ? 'http://localhost:4000' : 'https://outlineapp.vercel.app'

const client = new ApolloClient({ uri })

export const Provider = ({ children }) => {
	return <ApolloProvider client={client}>{children}</ApolloProvider>
}
